import type { FilterVariables } from '@swf/poker';
import { generateMTTReducer } from '@swf/poker';

import type { ActiveUiFilters } from '../types/';

import { defaultState } from './defaultState';
import type { PokerMultiTableTournamentsState as State } from './types';

export const reducers = {
  ...generateMTTReducer<State>(defaultState),
  setActiveUiFilters: (state: State, payload: ActiveUiFilters) => ({
    ...state,
    activeUiFilters: { ...state.activeUiFilters, ...payload }
  }),
  resetActiveFilters: (state: State, payload: FilterVariables) => ({
    ...state,
    activeFilters: payload,
    selectedTournamentId: 0
  })
};
